import { DangerousHtmlContent, Notification, variants } from '@eti/components';
import { LinkButton } from '@etg/wings';
import { useState } from 'react';
import { css } from '@eti/styles';
import OverlayDrawerForNotification from './OverlayDrawerForNotification';

export interface NotificationTextsProps {
  drawerContent: string;
  drawerHeader: string;
  notificationContent: string;
  notificationLinkText: string;
  notificationHeader: string;
  dataTestId: string;
}

const notificationWrapperStyles = css`
  padding: 16px 0;
`;

const NotificationWithOverLay = ({
  drawerContent,
  drawerHeader,
  notificationContent,
  notificationLinkText,
  notificationHeader,
  dataTestId,
}: NotificationTextsProps) => {
  const [showNotificationOverLay, setShowNotificationOverlay] = useState(false);

  const regex = new RegExp(/(\{LINK})/g);
  const textArray = notificationContent?.split(regex);
  const notificationContentWithLink = textArray?.map((str, index) => {
    if (regex.test(str)) {
      return (
        <LinkButton
          data-testid={`notification-link-button-${index}`}
          key={index}
          onClick={() => setShowNotificationOverlay(true)}
        >
          {notificationLinkText}
        </LinkButton>
      );
    }
    return (
      <DangerousHtmlContent
        component="span"
        content={str}
        dataTestId={`notification-content-${index}`}
        key={index}
      />
    );
  });

  return (
    <div className={notificationWrapperStyles}>
      <Notification
        dataTestId={dataTestId}
        title={notificationHeader}
        variant={variants.INFORMATION}
      >
        <>{notificationContentWithLink}</>
      </Notification>
      {drawerHeader && (
        <OverlayDrawerForNotification
          content={drawerContent}
          header={drawerHeader}
          isOpen={showNotificationOverLay}
          onClose={() => setShowNotificationOverlay(false)}
        />
      )}
    </div>
  );
};

export default NotificationWithOverLay;
